import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Alarm/Areas/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmLivestreamPerm';
import UpdateBox from 'components/Web_User_Interface/1440p_Series/Alarm/Areas/PrimaryBoxUpdates';
import InfoBox from 'components/Web_User_Interface/1440p_Series/Alarm/Areas/PrimaryBoxInfo';
import AreasTable from 'components/Web_User_Interface/1440p_Series/Alarm/Areas/areasTable';
import YoutubeVideoCardAlarm from 'components/Web_User_Interface/1440p_Series/Alarm/Actions/YoutubeVideoCardAlarm';
import YoutubeVideoCardAlarmAreas from 'components/Web_User_Interface/1440p_Series/Alarm/Areas/YoutubeVideoCardAlarmAreas';
import YoutubeVideoCardAlarmAreasUpdate from 'components/Web_User_Interface/1440p_Series/Alarm/Areas/YoutubeVideoCardAlarmAreasUpdate';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Alarm Menü // Alarmbereiche",
  "path": "/Web_User_Interface/1440p_Serie/Alarm/Bereiche/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Die Alarmbereiche entdecken Bewegung durch eine Bildanalyse, die auf jede Veränderung im Videobild reagiert. Sie können bis zu 4 Alarmbereiche auswählen - einfach den Bereich aktivieren und den Bereich in das Bild einzeichnen - und die Sensibilität für das Auslösen eines Alarms einstellen. Ist die Bewegungserkennung in einem Bereich aktiviert, können Sie die Sensibilität zwischen sehr unsensibel (Wert=0) und sehr sensibel (Wert=100) einstellen.",
  "image": "./WebUI_1440p_SearchThumb_Alarm_Alarm_Areas.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Alarm_Alarm_Areas.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='Alarm Menü // Alarmbereiche' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Die Alarmbereiche entdecken Bewegung durch eine Bildanalyse, die auf jede Veränderung im Videobild reagiert. Sie können bis zu 4 Alarmbereiche auswählen - einfach den Bereich aktivieren und den Bereich in das Bild einzeichnen - und die Sensibilität für das Auslösen eines Alarms einstellen. Ist die Bewegungserkennung in einem Bereich aktiviert, können Sie die Sensibilität zwischen sehr unsensibel (Wert=0) und sehr sensibel (Wert=100) einstellen.' image='/images/Search/WebUI_1440p_SearchThumb_Alarm_Alarm_Areas.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Alarm_Alarm_Areas.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Alarm/Areas/' locationFR='/fr/Web_User_Interface/1440p_Series/Alarm/Areas/' crumbLabel="Alarm Areas" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "alarm-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#alarm-men%C3%BC",
        "aria-label": "alarm menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Alarm Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "definieren-sie-bereiche-für-die-bewegungserkennung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#definieren-sie-bereiche-f%C3%BCr-die-bewegungserkennung",
        "aria-label": "definieren sie bereiche für die bewegungserkennung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Definieren Sie Bereiche für die Bewegungserkennung`}</h2>
    <p>{`Die Alarm Bereiche kennzeichnen die Gebiete im Bild, die für die software-basierte Erkennung von Bewegung herangezogen wird. In diesen Bereichen wird die Bewegungserkennung aufeinanderfolgenden Bilder Pixel-für-Pixel vergleichen und bei einer Veränderung, die den von Ihnen eingestellten Schwellenwert überschreitet, einen Alarm auslösen. aktivieren Sie einfach einen der 4 Bereiche und zeichnen sie diesen in den gewünschten Bildausschnitt ein, indem Sie die linke Maustaste gedrückt halten und die Maus bewegen. Der Schwellenwert für ein Alarmereignis kann über die Empfindlichkeit festgelegt werden - von sehr unempfindlich (Wert = 0) bis sehr empfindlich (Wert = 100). Die Empfindlichkeit wird darüber hinaus von der Größe des Bereiches bestimmt. Je kleiner der Bereich, desto mehr Fläche nimmt eine Änderung im Bild prozentual ein. Wenn Sie eine hohe Empfindlichkeit brauchen, setzten Sie viele kleine Alarmbereiche. Wenn Sie zu viele Fehlalarme erhalten, ist es besser einen großen Bereich aufzuziehen.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/82df1c61dc3c8537466fc771b0bc6b38/610c0/1440p_Settings_Alarm_Areas.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.60869565217392%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAADoklEQVQ4y42SS2xUZRiGz9q4c8+0hVLCUBGVUPECnRtlZnpu/5z/P2dm2s70fsE2EiiVtvRCL2OZTm/KohsjiYYQlkapNcYEEyXGHbJSS2ygYgMGdWnOY9oiGzYu3rxvvu/Nl++m2ROrmOMrvnnxS4zxVfSxL0iOrpAYWSE5uqVXSYysEr+wso2TwzeIX7ixnU9c2NHx4c+Rha+Jts2gtfac9lVTByHT80NWhojdQFLmML0WDJml3vEwVBqnIYfT0ISb60Bk2rDTLdjZdkSmFZFuQTV1EolbaKFwrX+spoa22rA/kDQYMlPkT1qYEUlX62U6Wpfp61lmeuIa4yMf05LrxRE6MiWwHA/pCJRjIaRLbeQE2ptVVfwwMOA/KhbZmJnl2tunKbY2MnFqkKWF+ywt/sVC6Q8K0w+YLf6NMs9jGnUoL7vdnVQKKSVuNk80GkN7aU/QX5sq8LhU4kFpjqXu9ziX7+FMQ57SpTUWSxsszK4zW7jL4uwmXbkCwk4ipcJLZ1DKRSlFNpslGo2iNao6Pi0VuN7RzXK2mU/6BmhLt9OVP83gue+ZHl9nvviQ+bnHzC3+Q2PjDJYZR7keSkmk4+A4Dp7nEYmE0V547nkCgV10dMYI2ceJH6rGPHYcz0tTLLTz/tQAn81N89HgIh9OfsVo27vYZh22SCEchUilsG2LlCMJR2Jor2SOcPZWP5fWp5i/P8PA1W6ajaMYyRrub0zxYGOSn+70c+dmB3dXmrjSV4tMOSjXxVINONLFVZKU20BtNI429vOYX/qzxMVfJ/0PHl3iKpfJyTew9aM8fDjH5maJjd9m2Ph9ls3Hc8yfi2MlDZSXRnpZlNwZ2800EY3F0LJXsoytjflTv4xw5uY79BYFQ3oN+fpX+ebbSb67dZ7bt4e58+MQ9+5NMHE2Qn1Cx/VcPM/Fdb3tK2fSHrGtgsHDL/sRO0Sm5YR/8PAhXnvxIAvNr9OZOEI0YRCKhkkkY1h2lHw+QV6GSAnx5F0UjrBIpQROOk04EkHrzTm+Y9kY9bYvHYl0FScNB912ELaNEFtLF1iWoL7eQjdTCCGwt3MCkWlGyizttqAuHEYrnkoghe7rhoFh6Oi6jmXomIaO8ST2H5um8Uxcb+4nne5iOJ4k+dYxtIqqaj8YPEB19QE/GNxPZWXl/8Tebd5bEWD37nJ2VVVRsWcPWjAYZH/wAPv2B9lbtY/y8vKnKCsrIxAIPOVnUUagbMdX/sT3LyptgUop1iH2AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/82df1c61dc3c8537466fc771b0bc6b38/e4706/1440p_Settings_Alarm_Areas.avif 230w", "/de/static/82df1c61dc3c8537466fc771b0bc6b38/d1af7/1440p_Settings_Alarm_Areas.avif 460w", "/de/static/82df1c61dc3c8537466fc771b0bc6b38/7f308/1440p_Settings_Alarm_Areas.avif 920w", "/de/static/82df1c61dc3c8537466fc771b0bc6b38/42d56/1440p_Settings_Alarm_Areas.avif 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/82df1c61dc3c8537466fc771b0bc6b38/a0b58/1440p_Settings_Alarm_Areas.webp 230w", "/de/static/82df1c61dc3c8537466fc771b0bc6b38/bc10c/1440p_Settings_Alarm_Areas.webp 460w", "/de/static/82df1c61dc3c8537466fc771b0bc6b38/966d8/1440p_Settings_Alarm_Areas.webp 920w", "/de/static/82df1c61dc3c8537466fc771b0bc6b38/a8acc/1440p_Settings_Alarm_Areas.webp 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/82df1c61dc3c8537466fc771b0bc6b38/81c8e/1440p_Settings_Alarm_Areas.png 230w", "/de/static/82df1c61dc3c8537466fc771b0bc6b38/08a84/1440p_Settings_Alarm_Areas.png 460w", "/de/static/82df1c61dc3c8537466fc771b0bc6b38/c0255/1440p_Settings_Alarm_Areas.png 920w", "/de/static/82df1c61dc3c8537466fc771b0bc6b38/610c0/1440p_Settings_Alarm_Areas.png 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/82df1c61dc3c8537466fc771b0bc6b38/c0255/1440p_Settings_Alarm_Areas.png",
              "alt": "Web User Interface - 1440p Series - Alarm Areas",
              "title": "Web User Interface - 1440p Series - Alarm Areas",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <AreasTable mdxType="AreasTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <InfoBox mdxType="InfoBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <YoutubeVideoCardAlarmAreas mdxType="YoutubeVideoCardAlarmAreas" />
    <EuiSpacer mdxType="EuiSpacer" />
    <YoutubeVideoCardAlarmAreasUpdate mdxType="YoutubeVideoCardAlarmAreasUpdate" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "zeitgesteuerte-bereicheinstellung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#zeitgesteuerte-bereicheinstellung",
        "aria-label": "zeitgesteuerte bereicheinstellung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Zeitgesteuerte Bereicheinstellung`}</h3>
    <p>{`Sie möchten unterschiedliche Bereich mit unterschiedlichen Sensitivitäten zu bestimmten Tageszeiten aktivieren? s. `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Zeitplan/"
      }}>{`Alarm/Alarmzeitplan`}</a>{` für eine Beschreibung der zeitgesteuerten Bereicheinstellung.`}</p>
    <h2 {...{
      "id": "einstellung-der-alarm-bereiche",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#einstellung-der-alarm-bereiche",
        "aria-label": "einstellung der alarm bereiche permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Einstellung der Alarm Bereiche`}</h2>
    <h3 {...{
      "id": "empfindlichkeit-größe-und-position",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#empfindlichkeit-gr%C3%B6%C3%9Fe-und-position",
        "aria-label": "empfindlichkeit größe und position permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Empfindlichkeit, Größe und Position`}</h3>
    <EuiSpacer mdxType="EuiSpacer" />
    <YoutubeVideoCardAlarm mdxType="YoutubeVideoCardAlarm" />
    <EuiSpacer mdxType="EuiSpacer" />
    <UpdateBox mdxType="UpdateBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Ein großer Bereich ist - in Bezug auf die Erklärung oben - viel resistenter gegen Falschalarme. Ein großer Bereich über das gesamte Bild wird nur einen Alarm auslösen, wenn eine Person nah an die Kamera herankommt. Um das etwas zu kompensieren, können Sie daher eine höhere Sensibilität auswählen.`}</p>
    <p>{`Um zu verhindern, dass Sie einen Alarm verpassen, fügen Sie einen kleineren Bereich einer kritischen Position im Bild hinzu (z.B. ein Fenster oder eine Haustür).`}</p>
    <p>{`Desto kleiner dieser Bereich ist, desto höher ist die Sensibilität. Um die optimale Einstellung herauszufinden, halten Sie ein Auge auf den `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/System/Log/"
      }}>{`System Log`}</a>{`. Ihrer Kamera. Wenn ein Bereich zu viele Fehlalarme auslöst, machen Sie Ihn größer oder verkleinern Sie die Sensibilität.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/809150c54e463785793d913607056749/3d405/1440p_Settings_Alarm_Areas_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "61.30434782608696%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAIAAADtbgqsAAAACXBIWXMAAAsTAAALEwEAmpwYAAACU0lEQVQoz33QyU8TUQDH8RekULB2sUvCEirwOnWj01kLKiVUEgOd9970TaeztVVTe9MLMaIGKpHEGE9c0JBwUDyoCJVVCkYTOfpXmRpiDBqTz+V3+F5+QK+t5eY3yZM6qh3DtbpWq9OHG9rsp/z8SXRuQ51dtxa28g9WwP3M+IosLaXklyl5KSUvj6ResLyYjKeXr7L6xYFgH+yNwp6mwe4mFWWtAqUqmVIweDY6djTENVjhkBUOWOEbL76HCRjr4r9L50r9HuD1uvyeFp+nxedt9Xtb/RhhyynlCybJaeDpaPqQ5Tc5cZsTtzjxsyCtxpPxeK/QkGARBsDZyJlwbyDc7QsHO0LBzjBSkFUs6wVTUZRm/IXltzhx51e/L0hvmSQT7xEOpFgZuoFv4kr/+oo8P30hfDoUaA+qRLVtk+aNrFb6X8yUYRvwoUz0R2Pk1fNExBMKuINIUaziTd2wEUL/iuNJ5nyfsJ+CRcYHQtFI1/BQX2KwJ9QZCXZEMCaObWl5XVHzf8WitBpLwFhAOLo0UO7yApfX1e4GbZ2gzX+q3e9yo2zWtEt6wcREBQuj6a8sv8OJe5y4y4kNXng3NCJJVe7xzGV0tz9agUw1xlRhrDoA7wzCiqoatuM0D0MEzF0b20zwHzjxIyeucVI9yb0WxzOZNX54V05vyxO78vXf9uTMNtVumQbN6QaiBWASVFFREWMHHbMQwdjAOQsRq7n+gLGt6WbBKjuGTZQsmKkobx6h204um9NUTSNNlFKinaRSVdGsMp1erJTuLU5OVW5M/gRvj9qBayTOCQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/809150c54e463785793d913607056749/e4706/1440p_Settings_Alarm_Areas_01.avif 230w", "/de/static/809150c54e463785793d913607056749/d1af7/1440p_Settings_Alarm_Areas_01.avif 460w", "/de/static/809150c54e463785793d913607056749/7f308/1440p_Settings_Alarm_Areas_01.avif 920w", "/de/static/809150c54e463785793d913607056749/47db3/1440p_Settings_Alarm_Areas_01.avif 1348w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/809150c54e463785793d913607056749/a0b58/1440p_Settings_Alarm_Areas_01.webp 230w", "/de/static/809150c54e463785793d913607056749/bc10c/1440p_Settings_Alarm_Areas_01.webp 460w", "/de/static/809150c54e463785793d913607056749/966d8/1440p_Settings_Alarm_Areas_01.webp 920w", "/de/static/809150c54e463785793d913607056749/4d989/1440p_Settings_Alarm_Areas_01.webp 1348w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/809150c54e463785793d913607056749/81c8e/1440p_Settings_Alarm_Areas_01.png 230w", "/de/static/809150c54e463785793d913607056749/08a84/1440p_Settings_Alarm_Areas_01.png 460w", "/de/static/809150c54e463785793d913607056749/c0255/1440p_Settings_Alarm_Areas_01.png 920w", "/de/static/809150c54e463785793d913607056749/3d405/1440p_Settings_Alarm_Areas_01.png 1348w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/809150c54e463785793d913607056749/c0255/1440p_Settings_Alarm_Areas_01.png",
              "alt": "Web User Interface - 1440p Series - Alarm Areas",
              "title": "Web User Interface - 1440p Series - Alarm Areas",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Im Beispiel (oben) sind alle 4 Alarme Bereiche aktiviert - jeweils mit einer Empfindlichkeit von 50%. Im Bild unten sieht man eine Visualisierung der Bewegungserkennung der Kamera, wenn man einen Gegenstand durch das Bild bewegt:`}</p>
    <p><img parentName="p" {...{
        "src": "/de/838a60e77a80311a0d95c7b37429e1ce/1440p_Settings_Alarm_Areas_02.gif",
        "alt": "Web User Interface - 1440p Series - Alarm Areas"
      }}></img></p>
    <p>{`Alle schwarzen Pixel werden als Hintergrund erkannt und somit ignoriert. Weiße Pixel sind Bildpunkte in denen eine Veränderung der Helligkeit und/oder Farbe erkannt wurden. Mit den gegebenen Einstellungen müssen mindestens 50% der Pixel in einem Bereich weiß werden, bevor ein Alarm ausgelöst wird. Je größer der Bereich ist, desto großflächiger muß auch die Bewegung vor der Kamera sein, damit ein Alarm ausgelöst wird.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Je höher die Empfindlichkeit UND je kleiner die Fläche eines Bereiches ist, desto schneller wird ein Alarm ausgelöst werden. Neben einer Reduzierung der Empfindlichkeit kann somit auch ein Vergrößern der Bereiche Fehlalarme eingrenzen.`}</p>
    </blockquote>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/40f614da7be76af60f019099931459a2/91b29/1440p_Settings_Alarm_Areas_03.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "22.17391304347826%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAIAAAABPYjBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA3ElEQVQI12PQ19fX0dHR1tbW0dHRAgNZObnQkOArF89eOHPy0vnTVy+evQJHF85cOHvy/JkTF8+d2rh+DYM2GGhpaWmCgZaWtrS4mLVHRNeut22bn3Rse96142XXjlddO15173rduf1l66Ynndtf9u1937r6ElSztra2JlS3tqy4mJxxgHHTdfOG82aNlyxbLlu1XrFsuWrbcd208aJG6UmD+sv2vfczZp1Bt1lTS1tGXEzFItim87ZN62W79mv2nTccum46dN107rlt137VqvG8fedN/xlPypdcBAAUr22GPyRCdgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/40f614da7be76af60f019099931459a2/e4706/1440p_Settings_Alarm_Areas_03.avif 230w", "/de/static/40f614da7be76af60f019099931459a2/d1af7/1440p_Settings_Alarm_Areas_03.avif 460w", "/de/static/40f614da7be76af60f019099931459a2/7f308/1440p_Settings_Alarm_Areas_03.avif 920w", "/de/static/40f614da7be76af60f019099931459a2/01a13/1440p_Settings_Alarm_Areas_03.avif 983w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/40f614da7be76af60f019099931459a2/a0b58/1440p_Settings_Alarm_Areas_03.webp 230w", "/de/static/40f614da7be76af60f019099931459a2/bc10c/1440p_Settings_Alarm_Areas_03.webp 460w", "/de/static/40f614da7be76af60f019099931459a2/966d8/1440p_Settings_Alarm_Areas_03.webp 920w", "/de/static/40f614da7be76af60f019099931459a2/b4d37/1440p_Settings_Alarm_Areas_03.webp 983w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/40f614da7be76af60f019099931459a2/81c8e/1440p_Settings_Alarm_Areas_03.png 230w", "/de/static/40f614da7be76af60f019099931459a2/08a84/1440p_Settings_Alarm_Areas_03.png 460w", "/de/static/40f614da7be76af60f019099931459a2/c0255/1440p_Settings_Alarm_Areas_03.png 920w", "/de/static/40f614da7be76af60f019099931459a2/91b29/1440p_Settings_Alarm_Areas_03.png 983w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/40f614da7be76af60f019099931459a2/c0255/1440p_Settings_Alarm_Areas_03.png",
              "alt": "Web User Interface - 1440p Series - Alarm Areas",
              "title": "Web User Interface - 1440p Series - Alarm Areas",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Wie zu erwarten wird die Bedingung - min. 50% der Pixel innerhalb eines Bereiches müssen sich ändern - nur bei den Bereichen 3 und 4 erfüllt. Bereich 1 und 2 lösen daher keinen Alarm aus.`}</p>
    <p>{`In einem zweiten Testlauf wird die Empfindlichkeit aller Bereiche auf 75% erhöht. Die Position und Größe wird beibehalten. Durch die höhere Empfindlichkeit reicht es jetzt bereits, wenn nur ein viertel eines Bereiches eine Bewegung sieht:`}</p>
    <p><img parentName="p" {...{
        "src": "/de/9d453258bc5bee37d8d8a4f79713460c/1440p_Settings_Alarm_Areas_04.gif",
        "alt": "Web User Interface - 1440p Series - Alarm Areas"
      }}></img></p>
    <p>{`Mit dieser Einstellung lösen jetzt alle Bereiche aus:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/037746ebd20a99c0d2309ad33755d7ba/58bb7/1440p_Settings_Alarm_Areas_05.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "18.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAIAAAABPYjBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA3klEQVQI12PQ0dHR0tLS1tbW0tLS1NTU0NCQlZXLzc5Ys2LJskXzVi5dsGrZwpVLEWj5kvnLFs1bsmDOqmWLGHR0dLTBAKZZU1xEpL53ztnn/4/e/X7i4e/TT/6dfvLvDAQ9/X/8wa/j93+eePDz3PP/DBBrNcFAS0tLTU1DUlBALajJvO2WRf1Zi6YLVs2XrFsuW7Vctmq9Ytt2xaDqtGHVGbOWa84THzIgW6ulpamqpiEpJKgT1ubQc9+h/bJj53XnnpsuPTede246995y67tl3XzRqumSbfftwFnPAbMRbzdEY3/kAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/037746ebd20a99c0d2309ad33755d7ba/e4706/1440p_Settings_Alarm_Areas_05.avif 230w", "/de/static/037746ebd20a99c0d2309ad33755d7ba/d1af7/1440p_Settings_Alarm_Areas_05.avif 460w", "/de/static/037746ebd20a99c0d2309ad33755d7ba/7f308/1440p_Settings_Alarm_Areas_05.avif 920w", "/de/static/037746ebd20a99c0d2309ad33755d7ba/01068/1440p_Settings_Alarm_Areas_05.avif 985w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/037746ebd20a99c0d2309ad33755d7ba/a0b58/1440p_Settings_Alarm_Areas_05.webp 230w", "/de/static/037746ebd20a99c0d2309ad33755d7ba/bc10c/1440p_Settings_Alarm_Areas_05.webp 460w", "/de/static/037746ebd20a99c0d2309ad33755d7ba/966d8/1440p_Settings_Alarm_Areas_05.webp 920w", "/de/static/037746ebd20a99c0d2309ad33755d7ba/8a0f1/1440p_Settings_Alarm_Areas_05.webp 985w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/037746ebd20a99c0d2309ad33755d7ba/81c8e/1440p_Settings_Alarm_Areas_05.png 230w", "/de/static/037746ebd20a99c0d2309ad33755d7ba/08a84/1440p_Settings_Alarm_Areas_05.png 460w", "/de/static/037746ebd20a99c0d2309ad33755d7ba/c0255/1440p_Settings_Alarm_Areas_05.png 920w", "/de/static/037746ebd20a99c0d2309ad33755d7ba/58bb7/1440p_Settings_Alarm_Areas_05.png 985w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/037746ebd20a99c0d2309ad33755d7ba/c0255/1440p_Settings_Alarm_Areas_05.png",
              "alt": "Web User Interface - 1440p Series - Alarm Areas",
              "title": "Web User Interface - 1440p Series - Alarm Areas",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "hintergrund-kompensation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#hintergrund-kompensation",
        "aria-label": "hintergrund kompensation permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hintergrund Kompensation`}</h3>
    <p>{`Bewegungen im Hintergrund - z.B. Bäume deren Blätter sich im Wind bewegen - sind ein häufiger Grund für Fehlalarme. Die 2k+ (WQHD) Kameras verfügen über einen Algorithmus der solche kontinuierlichen Bewegungen erkennt und der Kamera dabei hilft, diese herrauszufiltern. Im folgenden Beispiel haben wir die Kamera auf einen Ventilator ausgerichtet.`}</p>
    <p><img parentName="p" {...{
        "src": "/de/d0d28d15afce8daeaf10b1825a5b72fa/1440p_Settings_Alarm_Areas_06.gif",
        "alt": "Web User Interface - 1440p Series - Alarm Areas"
      }}></img></p>
    <p>{`Beim starten des Ventilators wird die Bewegung erkannt und würde einen Alarm auslösen. Nach kurzer Zeit springt jedoch die Hintergrunderkennung an und unterdrückt das Signal - der Ventilator fällt somit in den Hintergund und das Bild wird schwarz. Beim Ausschalten des Ventilators ändert sich die Frequenz, mit der der Rotor sich bewegt, und der Ventilator „fällt“ wieder aus dem Hintergrund heraus.`}</p>
    <p>{`Diese Funktion unterdrückt Fehlalarme. Kann aber auch „echte“ Alarme unterdrücken. Zum Beispiel, wenn eine Person sich längere Zeit vor der Kamera aufhält - in diesem Fall bekommt man häufig nur beim Ein- und Austreten einen Alarm.`}</p>
    <p><img parentName="p" {...{
        "src": "/de/5b536e63313648593c6b5c0ced920522/1440p_Settings_Alarm_Areas_07.gif",
        "alt": "Web User Interface - 1440p Series - Alarm Areas"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      